import React from 'react';
import './progress.css';
import { makeStyles } from 'tss-react/mui';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    '& > * + *': {
      marginLeft: theme.spacing(2)
    },
  },
}));

function ProgressBar(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CircularProgress sx={{color:"#ce2a1d"}} size={ props.size   ? props.size   : 0.99 * 100}  />
    </div>
  );
}
export default ProgressBar;